import { DELIVERABLE_TYPES } from "../../lib/deliverableConfig";
import { cn } from "@/lib/utils";

export default function DeliverableTypeSelector({ value, onChange, className }) {
  return (
    <div
      className={cn(
        "inline-flex flex-wrap gap-1 p-1 rounded-xl bg-slate-100/90 border border-slate-200/80 shadow-sm",
        className
      )}
      role="tablist"
      aria-label="Tipo de documento"
    >
      {DELIVERABLE_TYPES.map((t) => {
        const active = value === t.id;
        return (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(t.id)}
            className={cn(
              "px-3.5 py-2 text-sm font-medium rounded-lg transition-colors min-w-[8rem]",
              active
                ? "bg-white text-slate-900 shadow-sm border border-slate-200/90"
                : "text-slate-600 hover:text-slate-900 hover:bg-white/60"
            )}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
